'use client';
import { useEffect } from 'react';
import { isDevelopment } from '@/shared/config/brand-by-target.mjs';

const ReloadOnOnline = () => {
  useEffect(() => {
    if (isDevelopment) return;

    const reload = () => {
      window.location.reload();
    };

    window.addEventListener('online', reload);

    return () => {
      window.removeEventListener('online', reload);
    };
  }, []);

  return null;
};

export { ReloadOnOnline };
